<template>
  <div class="video-card" :class="{ 'video-card--clickable': lazy }">
    <!-- Lazy mode: show thumbnail + play overlay, load iframe only on click -->
    <button
      v-if="lazy && !activated"
      type="button"
      class="video-card__placeholder"
      @click="activate"
    >
      <img
        v-if="thumbnailUrl"
        class="video-card__thumb"
        :src="thumbnailUrl"
        alt="Video preview"
        loading="lazy"
      />
      <div v-else class="video-card__thumb video-card__thumb--fallback"></div>

      <div class="video-card__overlay">
        <div class="video-card__play">
          <span class="video-card__play-triangle"></span>
        </div>
        <div class="video-card__overlay-text">Play video</div>
      </div>
    </button>

    <iframe
      v-else
      :src="url"
      frameborder="0"
      width="100%"
      height="100%"
      allowfullscreen
      loading="lazy"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      required: true,
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      result: "",
      valid: false,
      url: "",
      activated: false,
      thumbnailUrl: "",
      videos: [
        {
          // eslint-disable-next-line no-useless-escape
          reg: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/i,
          url: "https://www.youtube.com/embed/$5",
          thumb: (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`,
          params: {
            "picture-in-picture": 1,
            "encrypted-media": 1,
            accelerometer: 1,
            gyroscope: 1,
            autoplay: 0,
          },
        },
        {
          reg: /^.*vimeo.com\/(\d+)($|\/|\b)/i,
          url: "https://player.vimeo.com/video/$1",
          thumb: null,
          params: {
            title: 0,
            byline: 0,
            portrait: 0,
          },
        },
      ],
    };
  },
  watch: {
    src() {
      this.parse();
      this.activated = false;
    },
  },
  methods: {
    activate() {
      this.activated = true;
    },
    parse() {
      this.thumbnailUrl = "";

      if (this.src) {
        for (let i = 0; i < this.videos.length; i++) {
          const v = this.videos[i];
          const m = v.reg.exec(this.src);
          if (m) {
            const id = m[5] || m[1];
            if (v.thumb && id) {
              this.thumbnailUrl = v.thumb(id);
            }

            // NOTE: this.params isn't defined anywhere in this component today;
            // keep current behavior but don't depend on it.
            const params = Object.assign({}, v.params, this.params);
            const query = Object.keys(params)
              .map((key) => key + "=" + params[key])
              .join("&");
            const and = v.url.indexOf("?") >= 0 ? "&" : "?";
            this.url = this.src.replace(v.reg, v.url) + and + query;
            this.valid = true;
            return;
          }
        }
      }
      this.valid = false;
    },
  },
  mounted() {
    this.parse();
  },
};
</script>

<style scoped>
.video-card {
  width: 100%;
  height: 100%;
}

.video-card__placeholder {
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  position: relative;
  cursor: pointer;
  border-radius: 20px;
  overflow: hidden;
}

.video-card__thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.video-card__thumb--fallback {
  background: rgb(var(--v-theme-background2));
}

.video-card__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.05) 0%,
    rgba(0, 0, 0, 0.45) 100%
  );
}

.video-card__play {
  width: 64px;
  height: 64px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
}

.video-card__play-triangle {
  width: 0;
  height: 0;
  border-left: 14px solid rgb(var(--v-theme-primary));
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  margin-left: 3px;
}

.video-card__overlay-text {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
}
</style>
